import type { FunctionComponent } from 'react'
import { useCallback } from 'react'
import styled from 'styled-components'
import getShareUrl, { ShareTarget } from '../../utils/shareUrl'
import Icon from '../Icon/Icon'
import Facebook from '../../assets/icons/facebook.svg'
import Email from '../../assets/icons/email.svg'
import Linkedin from '../../assets/icons/linkedIn.svg'
import Print from '../../assets/icons/print.svg'
import XLogo from '../../assets/icons/xLogo.svg'
import Button from '../Button/Button'

const ShareBarContainer = styled.div`
  display: flex;
  & > * {
    margin-right: 5px;
  }
`

const ShareButton = styled(Button)`
  background-color: var(--greyText);
  color: var(--light);
  svg {
    fill: var(--light);
  }
  &:hover {
    background-color: var(--red);
  }
`

const ShareBar: FunctionComponent = ({ ...otherProps }) => {
  const handlePageShare = useCallback((target: ShareTarget) => {
    const link = getShareUrl(target)
    if (link) {
      window.open(link.url, link.target)
    }
  }, [])

  return (
    <ShareBarContainer {...otherProps} data-testid="sharebar">
      <ShareButton
        type="button"
        size={30}
        onClick={() => handlePageShare(ShareTarget.Facebook)}
        title="Deel op Facebook"
      >
        <Icon size={24}>
          <Facebook />
        </Icon>
      </ShareButton>
      <ShareButton
        type="button"
        size={30}
        onClick={() => handlePageShare(ShareTarget.Twitter)}
        title="Deel op X"
      >
        <Icon size={22}>
          <XLogo />
        </Icon>
      </ShareButton>
      <ShareButton
        type="button"
        size={30}
        onClick={() => handlePageShare(ShareTarget.LinkedIn)}
        title="Deel op LinkedIn"
      >
        <Icon size={22}>
          <Linkedin />
        </Icon>
      </ShareButton>
      <ShareButton
        type="button"
        size={30}
        onClick={() => handlePageShare(ShareTarget.Email)}
        title="Deel via email"
      >
        <Icon size={22}>
          <Email />
        </Icon>
      </ShareButton>
      <ShareButton
        type="button"
        size={30}
        onClick={() => {
          window.print()
        }}
        title="Print deze pagina"
      >
        <Icon size={24}>
          <Print />
        </Icon>
      </ShareButton>
    </ShareBarContainer>
  )
}

export default ShareBar
